import Accordion from 'components/shared/accordion/Accordion';
import { AccordionItemProps } from 'components/shared/accordion/Accordion.types';
import HtmlTrans from 'components/shared/HtmlTrans';
import { TFunction } from 'hooks/useI18n';
import MethodologyExperience from './charts/ MethodologyExperience';
import MethodologyGender from './charts/MethodologyGender';
import MethodologyRoles from './charts/MethodologyRoles';
import {
  MethodologyExperienceDataProps,
  MethodologyGenderDataProps,
  MethodologyRolesDataProps,
  MethodologySectionProps
} from './Methodology.types';

const genderAccordion = (t: TFunction): AccordionItemProps[] => [
  {
    summary: t('mandecar23.methodology.gender.api-title'),
    details: (
      <HtmlTrans
        ns="developer-career-report-2023"
        i18nKey="mandecar23.methodology.gender.api-content"
      />
    )
  },
  {
    summary: t('mandecar23.methodology.gender.question-title'),
    details: (
      <HtmlTrans
        ns="developer-career-report-2023"
        i18nKey="mandecar23.methodology.gender.question-content"
      />
    )
  }
];

export const METHODOLOGYSECTIONS = (
  t: TFunction
): MethodologySectionProps[] => [
  {
    title: t('mandecar23.methodology.experience.title'),
    desc: 'mandecar23.methodology.experience.desc',
    chart: <MethodologyExperience />
  },
  {
    title: t('mandecar23.methodology.roles.title'),
    desc: 'mandecar23.methodology.roles.desc',
    chart: <MethodologyRoles />
  },
  {
    title: t('mandecar23.methodology.gender.title'),
    desc: 'mandecar23.methodology.gender.desc',
    chart: <MethodologyGender />,
    accordion: <Accordion items={genderAccordion(t)} />
  }
];

export const METHODOLOGYEXPERIENCE: MethodologyExperienceDataProps[] = [
  {
    exp: '<2y',
    share: 11.998053054271113
  },
  {
    exp: '2-5y',
    share: 16.776182363916607
  },
  {
    exp: '5-10y',
    share: 14.969849382115141
  },
  {
    exp: '>10y',
    share: 18.179605743489898
  }
];

export const METHODOLOGYROLES: MethodologyRolesDataProps[] = [
  {
    role: 'Backend Developer',
    share: 17.406480709233
  },
  {
    role: 'Full-stack Developer',
    share: 13.310474778364686
  },
  {
    role: 'Frontend Developer',
    share: 13.08188922867822
  },
  {
    role: 'Tech Lead',
    share: 3.916844283816761
  },
  {
    role: 'Project & Delivery Manager',
    share: 3.4457727118277575
  },
  {
    role: 'DevOps & Infra. & SRE',
    share: 3.147684799060946
  },
  {
    role: 'Software Architect',
    share: 2.8773978315262716
  },
  {
    role: 'Mobile Developer',
    share: 2.67197973619992
  },
  {
    role: 'Engineering Management',
    share: 2.1854631946375065
  },
  {
    role: 'Data Analysis & BI',
    share: 2.1777407098508017
  }
];

export const METHODOLOGYGENDER = (
  locale: string | undefined
): MethodologyGenderDataProps[] => [
  { name: locale === 'es' ? 'Mujeres' : 'Women', value: 13.436102388428965 },
  { name: locale === 'es' ? 'Hombres' : 'Men', value: 77.26710438671614 },
  {
    name: locale === 'es' ? 'Indeterminado' : 'Unknown',
    value: 8.583119231135218
  }
];
